import {Trans} from '@lingui/macro';
import React from 'react';

import {HandlerOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {FolderBreadcrumb} from '../../../components/folderBreadcrumbs/folderBreadcrumbs';
import {isTeammateNamespace, isTeamNamespace} from '../../../helpers/models/namespaceHelpers';
import {TeammateModel} from '../../../models/api/teammateModel';
import {getRulesRoute} from '../ruleHelpers';

/*
 * Constants.
 */

const INDIVIDUAL_RULES_LABEL = <Trans id="rule-editor-breadcrumbs-individual-rules">Individual rules</Trans>;

/*
 * Helpers.
 */

export function buildRuleEditorBreadcrumbs(
  namespace: string,
  isRecipe: boolean,
  isInboxCreation: boolean,
  navigateToLink: HandlerOf<string>,
): ReadonlyArray<FolderBreadcrumb> {
  const breadcrumbs: Array<FolderBreadcrumb> = [];

  const ruleRoute = getRulesRoute(namespace);

  if (isInboxCreation) {
    return [
      {
        label: <Trans id="rule-editor-breadcrumbs-inbox-creation">Inbox creation</Trans>,
        onBreadcrumbClick: () => navigateToLink(`/settings/${namespace}/inboxes/new/inbox/rules`),
      },
      {
        label: <Trans id="rule-editor-breadcrumbs-rule-library">Rule library</Trans>,
        onBreadcrumbClick: () => navigateToLink(`/settings/${namespace}/inboxes/new/inbox/rules`),
      },
    ];
  }

  if (isTeammateNamespace(namespace)) {
    breadcrumbs.push({
      label: INDIVIDUAL_RULES_LABEL,
      onBreadcrumbClick: () => navigateToLink(ruleRoute),
    });
  } else if (isTeamNamespace(namespace)) {
    breadcrumbs.push({
      label: <Trans id="rule-editor-breadcrumbs-team-rules">Team rules</Trans>,
      onBreadcrumbClick: () => navigateToLink(ruleRoute),
    });
  } else {
    breadcrumbs.push({
      label: <Trans id="rule-editor-breadcrumbs-global-rules">Company rules</Trans>,
      onBreadcrumbClick: () => navigateToLink(ruleRoute),
    });
  }

  if (isRecipe) {
    breadcrumbs.push({
      label: <Trans id="rule-editor-breadcrumbs-rule-library">Rule library</Trans>,
      onBreadcrumbClick: () => navigateToLink(`${ruleRoute}/library`),
    });
  }

  return breadcrumbs;
}

export function buildRuleEditorBreadcrumbsForOtherTeammate(
  teamNamespace: string,
  teammate: TeammateModel,
  navigateToLink: HandlerOf<string>,
) {
  const teammateListRoute = `/settings/${teamNamespace}/teammates`;
  const teammateRoute = `${teammateListRoute}/edit/${teammate.alias}`;

  return [
    {
      label: <Trans id="rule-editor-breadcrumbs-teammate-list">Teammates</Trans>,
      onBreadcrumbClick: () => navigateToLink(teammateListRoute),
    },
    {
      label: teammate.givenName || (
        <Trans id="rule-editor-breadcrumbs-teammate-no-given-name">Teammate</Trans>
      ),
      onBreadcrumbClick: () => navigateToLink(teammateRoute),
    },
    {
      label: INDIVIDUAL_RULES_LABEL,
      onBreadcrumbClick: () => navigateToLink(`${teammateRoute}/rules`),
    },
  ];
}
